export default "__VITE_ASSET__C8KATfZU__"